const coursesByCategory = [
  {
    category: {
      en: "Hospitality",
      zh: "酒店",
    },
    count: 1590,
  },
  {
    category: {
      en: "Food and Beverage",
      zh: "餐飲",
    },
    count: 2680,
  },
  {
    category: {
      en: "Heritage and Tourism",
      zh: "文化遺產及旅遊",
    },
    count: 2053,
  },
  {
    category: {
      en: "Retail, Events and Business",
      zh: "零售、會展及商業",
    },
    count: 4362,
  },
  {
    category: {
      en: "Creative Studies and IT",
      zh: "創意藝術及資訊科技",
    },
    count: 2142,
  },
  {
    category: {
      en: "Health, Spa and Beauty ",
      zh: "健康、美容及美療",
    },
    count: 474,
  },
  {
    category: {
      en: "Language and Culture",
      zh: "語言文化",
    },
    count: 2430,
  },
  {
    category: {
      en: "Personal Development",
      zh: "自我提升",
    },
    count: 1295,
  },
  {
    category: {
      en: "Extra-curricular Activities",
      zh: "課外活動",
    },
    count: 347,
  },
  {
    category: {
      en: "Others",
      zh: "其他",
    },
    count: 429,
  },
]

const coursesByType = [
  {
    type: {
      en: "Diploma Programmes",
      zh: "文憑課程",
    },
    count: 183,
  },
  {
    type: {
      en: "Community Education and Development Programme",
      zh: "社區教育發展計劃課程",
    },
    count: 2990,
  },
  {
    type: {
      en: "Customised Courses",
      zh: "特設課程",
    },
    count: 6390,
  },
  {
    type: {
      en: "Courses Leading to Internationally Recognised Qualifications",
      zh: "國際認證",
    },
    count: 911,
  },
  {
    type: {
      en: "Macao Occupational Skills Recognition System (MORS)",
      zh: "澳門職業技能認可基準（MORS）",
    },
    count: 777,
  },
  {
    type: {
      en: "Other Short Professional Courses",
      zh: "其他短期專業課程",
    },
    count: 5301,
  },
  {
    type: {
      en: "Pre-service Vocational Training Programmes",
      zh: "職前技能培訓課程",
    },
    count: 1167,
  },
  {
    type: {
      en: "Technical and Professional High School Programme",
      zh: "技術及專業中學課程",
    },
    count: 83,
  },
]

const sumOfCourseTraineesByCategory = coursesByCategory.reduce((sum, course) => (sum + course.count), 0)
const sumOfCourseTraineesByType = coursesByType.reduce((sum, course) => (sum + course.count), 0)

export {
  coursesByCategory,
  coursesByType,
  sumOfCourseTraineesByCategory,
  sumOfCourseTraineesByType,
}
